import { createReducer } from '@reduxjs/toolkit';

import * as actions from './actions';
import type { AdvancedSecurityState } from './types';

export const initialData = {
    requireTwoFactorAuth: false,
    ssoEnabled: false,
    ssoRequired: false,
    ssoDomain: undefined,
    ssoSamlIdpEndpointUrl: undefined,
    ssoSamlIdpIssuer: undefined,
    ssoSamlIdpCertificate: undefined,
    ssoSamlStrict: false,
    securePassEnabled: false,
    passExpireEnabled: false,
    passExpireValue: undefined,
    passHistoryEnabled: false,
    passHistoryValue: undefined,
    passLengthEnabled: false,
    passLengthValue: undefined,
    passComplexityEnabled: true,
    passComplexityValue: ['upper', 'lower', 'special'],
    privacyMode: undefined,
};

export const initialState: AdvancedSecurityState = {
    data: initialData,
    submitting: false,
    errorMessage: null,
    spCertificate: '',
};

const reducers = createReducer<AdvancedSecurityState>(initialState, (builder) => {
    builder.addCase(actions.setSubmitting, (state, { payload }) => ({ ...state, submitting: payload }));
    builder.addCase(actions.setErrorMessage, (state, { payload }) => ({ ...state, errorMessage: payload }));
    builder.addCase(actions.setSpCertificate, (state, { payload }) => ({ ...state, spCertificate: payload }));
    builder.addCase(actions.updateFormData, (state, { payload }) => ({
        ...state,
        ...{ data: { ...state.data, ...payload } },
    }));
});

export default reducers;
